import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import useContext from '../../../context';

export default function PointsInput() {
  const [context, updateContext] = useContext();

  return (
    <div className="quoteform__grid quoteform__grid--isMdVertical">
      <div className="quoteform__input">
        <TextField
          fullWidth
          label="Number of points"
          variant="outlined"
          type="number"
          name="points"
          InputLabelProps={{ shrink: true }}
          value={context.totalPoints}
          onChange={({ target: { value } }) => updateContext((ctx) => {
            ctx.totalPoints = value;

            return ctx;
          })}
          inputProps={{ min: 1, 'aria-label': 'Number of points' }}
        />
      </div>
      {
        context.contractType === 'new' && (
          <div className="quoteform__input">
            <TextField
              fullWidth
              label="Price per point"
              variant="outlined"
              type="number"
              name="pricePerPoint"
              InputLabelProps={{ shrink: true }}
              value={context.pricePerPoint}
              onChange={({ target: { value } }) => updateContext((ctx) => {
                ctx.pricePerPoint = value;
    
                return ctx;
              })}
              inputProps={{ min: 1, 'aria-label': 'Price per point' }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          </div>
        )
      }
      {
        context.contractType === 'refinance' && (
          <div className="quoteform__input">
            <TextField
              fullWidth
              label="Existing Loan Payoff"
              helperText="Leave this field empty if you do not currently have a loan."
              variant="outlined"
              type="number"
              name="existingLoanPayoff"
              InputLabelProps={{ shrink: true }}
              value={context.existingLoanPayoff}
              onChange={({ target: { value } }) => updateContext((ctx) => {
                ctx.existingLoanPayoff = value;

                return ctx;
              })}
              inputProps={{ min: 0, 'aria-label': 'Existing Loan Payoff' }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          </div>
        )
      }
    </div>
  );
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/PointsInput.js